<ion-content>
  <header mode="small" title="Kontakt" subtitle=""></header>

  <main class="container mx-auto px-5 py-10"></main>

  <footer></footer
></ion-content>
